<template>
  <div class="page" :style="{ 'padding-top': safeArea.top + 'px' }">
    <div class="page-nav">
      <slot name="nav"> </slot>
    </div>
    <div
      v-if="hasHead"
      class="page-head"
    >
      <div v-if="title" class="page-head-default" :style="{ 'padding-top': safeArea.top + 'px' }">
        <!-- 对齐 App：白底导航用黑色返回箭头；showBack=false 时隐藏（wallet_list 在用） -->
        <img v-if="showBack" src="../../assets/imgs/icon_back.png" alt="" @click="onBack" />
        <img class="head_logo" src="../../assets/imgs/img_logo.png" alt="" />
        <!-- {{ title }} -->
      </div>
      <slot name="head"> </slot>
    </div>
    <div class="page-body">
      <slot></slot>
    </div>
    <div class="page-foot" v-if="hasFoot">
      <slot name="foot"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(["safeArea"]),
    hasHead() {
      return this.$slots.head || this.title
    },
    hasFoot() {
      return this.$slots.foot
    }
  },
  methods: {
    // 对齐 AppHeader onBack：返回上一页，无历史时兜底跳主页 /map
    onBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push("/map")
      }
    }
  }
}
</script>

<style lang="less">
// @navBgColor: linear-gradient(135deg, #ee590f 0%, #c4fe01 100%);
@navBgColor: rgba(0,0,0,0);
.page {
  &-head {
    background: @navBgColor;
    position: fixed;
    z-index: 99;
    top: 0;
    width: 100%;
    font-size: 36px;
    &-default {
      // 给 logo 留出顶部空间，避免紧贴头部
      min-height: 150px;
      padding-top: 30px;
      padding-bottom: 20px;
      position: relative;
      color: #ffffff;
      // 返回按钮（左上），规格对齐 AppHeader（img 56x56 / left 30px）
      img {
        height: 56px;
        width: 56px;
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
      }
      // logo（顶部居中，与返回按钮基线对齐）
      .head_logo {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 70px;
        max-width: 50%;
        width: auto;
      }
    }
  }
  &-head + &-body {
    // padding-top 与 head 高度对齐
    padding-top: 150px;
  }
  &-foot {
    background: #ffffff;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  &-nav {
    background: @navBgColor;
    font-size: 36px;
  }
}
</style>
